export default "__VITE_ASSET__BPnK9Md6__"